module.exports = __webpack_public_path__ + "img/animation_bike.32ee556a.gif";